import { create } from "zustand";
import { MessageBannerState, MessageType } from "../components/MessageBannerContext";

interface MessageBannerStore extends MessageBannerState {
  setBanner: (message: string, type: MessageType) => void;
  closeBanner: () => void;
}

export const useMessageBannerStore = create<MessageBannerStore>((set) => ({
  open: false,
  message: "",
  type: "info",
  setBanner: (message, type) => set({ open: true, message, type }),
  closeBanner: () => set({ open: false, message: "", type: "info" }),
}));
